import { loadScript } from 'src/util/helper';

const API_KEY = process.env.VUE_APP_GOOGLE_API_KEY;

window.googleApi = loadScript(`https://maps.googleapis.com/maps/api/js?key=${API_KEY}&libraries=places`)
	.catch(console.error);
